export default __webpack_public_path__ + "static/6-480d05cb2dd33d74b26be9c8e5426123.gif";